module.exports = __webpack_public_path__ + "static/img/voice5_right.5294303a.png";